import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Adminprofile() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
    role: "",
  });

  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [data, setData] = useState(null);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email || decoded.phoneNumber);
      setRole(decoded.role);
      if (decoded.role !== "admin") {
        navigate("/login");
      }
    }
  }, []);

  useEffect(() => {
    axios
      .get(`https://api.litaxfilers.com/get/admindetails/${username}`)
      .then((response) => {
        setData(response.data);
        if (response.data && response.data.length > 0) {
          setFormData({
            userName: response.data[0].userName || "",
            email: response.data[0].email || "",
            phoneNumber: response.data[0].phoneNumber || "",
            role: response.data[0].role || "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [username]);

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <h4>My Profile Details</h4>
            <form className=" mt-2">
              <div className="form-group mb-2">
                <label>User Name:</label>
                <input
                  type="text"
                  value={formData.userName}
                  readOnly
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label>Email:</label>
                <input
                  type="email"
                  value={formData.email}
                  readOnly
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label>Phone Number:</label>
                <input
                  type="text"
                  value={formData.phoneNumber}
                  readOnly
                  className="form-control"
                />
              </div>
              {/* <div className="form-group mb-2">
                <label>Role:</label>
                <input
                  type="text"
                  value={formData.role}
                  readOnly
                  className="form-control"
                />
              </div> */}
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Adminprofile;
